module.exports = __webpack_public_path__ + "d2bbef8275694e1bde6399527c7a851d.svg";